export const getStringInitials = (string: string) => {
  const splitted = (string || '').split(' ')
  return {
    firstLetter: (splitted[0] && splitted[0][0].toUpperCase()) || '',
    secondLetter: (splitted[1] && splitted[1][0].toUpperCase()) || ''
  }
}
